// extracted by mini-css-extract-plugin
export default {"padTitle":"Agent_padTitle__-j64Z","agentsForm":"Agent_agentsForm__ZcdC6"};